import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import * as colors from '~/constants/colors'

const partnershipHeroLg = `${process.env.GATSBY_IMAGES}partnership/digital_doctor_partnerships_lg.png`;
const partnershipHeroMd = `${process.env.GATSBY_IMAGES}partnership/digital_doctor_partnerships_md.png`;
const partnershipHeroSm = `${process.env.GATSBY_IMAGES}partnership/digital_doctor_partnerships_sm.png`;
const pricing = `${process.env.GATSBY_IMAGES}partnership/pricing.jpg`;
const pricingDiagram = `${process.env.GATSBY_IMAGES}partnership/pricing-diagram.png`;

import { TYPOGRAPHY } from '~/constants/typography'

export default makeStyles((theme: Theme) =>
    createStyles({
        hero1: {
            marginTop: theme.spacing(4),
            background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${partnershipHeroLg})`,
            [theme.breakpoints.down('md')]: {
                background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${partnershipHeroMd})`,
            },
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(0),
                background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${partnershipHeroSm})`,
            },
        },
        hero2: {
            background: `linear-gradient(rgba(0, 22, 94, 0.4), rgba(0, 22, 94, 0.4)), url(${pricing})`,
        },
        hero: {
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            width: '100%',
            height: 465,
            [theme.breakpoints.down('md')]: {
                height: 331,
            },
            [theme.breakpoints.down('sm')]: {
                height: 432,
                borderRadius: 0,
            },
            [theme.breakpoints.down('xs')]: {
                height: 500,
            },
        },
        heroInner: {
            paddingTop: `${theme.spacing(8)}px !important`,
        },
        heroTitle: {
            color: colors.WHITE_COLOR,
            textAlign: 'center',
            [theme.breakpoints.down('md')]: {
                ...TYPOGRAPHY.h4,
            },
        },
        heroContainer: {
            boxSizing: 'content-box',
            [theme.breakpoints.down('md')]: {
              boxSizing: 'border-box',
            },
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        partnering: {
            [theme.breakpoints.down('xs')]: {
                marginTop: theme.spacing(8),
            },
        },
        text: {
            color: colors.GREY_COLOR.Grey1,
        },
        services: {
            margin: theme.spacing(0, -2),
            marginTop: theme.spacing(4),
        },
        service: {
            '&&': {
                padding: theme.spacing(1, 2),
                [theme.breakpoints.down('md')]: {
                    padding: theme.spacing(1, 1.5),
                },
                [theme.breakpoints.down('sm')]: {
                    padding: theme.spacing(1.5, 1.5),
                },
                [theme.breakpoints.down('xs')]: {
                    padding: theme.spacing(1, 2),
                },
            },
        },
        centered: {
            textAlign: 'center',
        },
        sectionTitle: {
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down('md')]: {
                ...TYPOGRAPHY.subtitle1,
            },
        },
        versus: {
            marginTop: theme.spacing(7),
            display: 'flex',
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        versusCard: {
            maxWidth: 336,
            minHeight: 180,
            width: '100%',
            boxSizing: 'border-box',
            marginRight: theme.spacing(4),
            '&:last-child': {
                marginRight: 0,
                [theme.breakpoints.down('xs')]: {
                    marginBottom: 0,
                },
            },
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
            padding: theme.spacing(3),
            borderRadius: 4,
            [theme.breakpoints.down('sm')]: {
                marginRight: theme.spacing(2),
            },
            [theme.breakpoints.down('xs')]: {
                maxWidth: 'initial',
                marginRight: 0,
                marginBottom: theme.spacing(2),
            },
        },
        competitor: {
            color: colors.GREY_COLOR.Grey2,
            background: colors.GREY_COLOR.Grey5,
        },
        orthosnap: {
            color: colors.WHITE_COLOR,
            background: theme.palette.primary.dark,
        },
        versusTitle: {
            color: 'inherit',
            display: 'block',
            marginBottom: theme.spacing(2),
        },
        versusList: {
            padding: 0,
            margin: 0,
        },
        versusItem: {
            listStyle: 'none',
            display: 'flex',
            marginBottom: theme.spacing(1),
            '&:last-child': {
                marginBottom: theme.spacing(0),
            },
        },
        versusText: {
            marginLeft: theme.spacing(2),
        },
        versusIcon: {
            '&& g': {
                fill: 'inherit',
            },
        },
        pricingContainer: {
            paddingTop: theme.spacing(10),
            marginBottom: 0,
            paddingBottom: 128,
            [theme.breakpoints.down('xs')]: {
                paddingTop: theme.spacing(8),
            },
        },
        pricingBox: {
            maxWidth: 928,
            width: '100%',
            margin: '0 auto',
            background: colors.WHITE_COLOR,
            borderRadius: 4,
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
            padding: theme.spacing(6, 4),
            boxSizing: 'border-box',
            marginTop: theme.spacing(8),
            color: '#393c3f',
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('md')]: {
                maxWidth: 776,
            },
            [theme.breakpoints.down('sm')]: {
                maxWidth: 512,
                flexDirection: 'column',
                alignItems: 'flex-start',
            },
            [theme.breakpoints.down('xs')]: {
                maxWidth: 'initial',
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginTop: theme.spacing(5),
                padding: theme.spacing(4, 2),
            },
        },
        pricingImage: {
            backgroundImage: `url(${pricingDiagram})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            maxWidth: 416,
            height: 402,
            width: '100%',
            marginRight: theme.spacing(9),
            [theme.breakpoints.down('md')]: {
                maxWidth: 351,
                height: 339,
                marginRight: theme.spacing(5.5),
            },
            [theme.breakpoints.down('sm')]: {
                maxWidth: 426,
                height: 410,
                marginRight: 0,
                marginBottom: 78,
            },
            [theme.breakpoints.down('xs')]: {
                maxWidth: 311,
                height: 300,
                marginRight: 0,
                marginBottom: theme.spacing(6),
                alignSelf: 'center',
            },
        },
    })
)
